// import { Member } from "common/api/models/Member";

// the git commit hash provided at build time.
const appVersion = process.env.REACT_APP_COMMIT;

// Wrapper around track that always passes the app version.
const track = (event: string, data?: any) => (window as any).analytics.track(event, { ...data, appVersion });

export const Analytics = {
  member: {
    update() {
      track('Member Updated');
    },
    invite() {
      track('Member Invited');
      track('Member Created');
    },
    removeEmployee() {
      track('Member Employee Removed');
      track('Member Updated');
    },
    promoteEmployee() {
      track('Member Employee Promoted');
      track('Member Updated');
    },
    demoteEmployee() {
      track('Member Employee Demoted');
      track('Member Updated');
    },
    create() {
      track('Member Created');
    },
    search(params: any) {
      track('Member Searched', params);
    },
    export() {
      track('Member Exported');
    },
    note() {
      track('Member Note Created');
    },
    ceu() {
      track('Member CEU Created');
    },
    resetPassword() {
      track('Member Password Reset');
    },
  },
  product: {
    update() {
      track('Product Updated');
    },
    create() {
      track('Product Created');
    },
  },
  tag: {
    update() {
      track('Tag Updated');
    },
    create() {
      track('Tag Created');
    },
  },
  vftiRegistrant: {
    update() {
      track('VftiRegistrant Updated');
    },
    create() {
      track('VftiRegistrant Created');
    },
  },
  summitRegistrant: {
    update() {
      track('SummitRegistrant Updated');
    },
    create() {
      track('SummitRegistrant Created');
    },
  },
  order: {
    refund() {
      track('Order Refunded');
    },
    sendInvoiceLetter() {
      track('Order Invoice Letter Sent');
    },
    sendInvoiceEmail() {
      track('Order Invoice Email Sent');
    },
    adjust() {
      track('Order Adjusted');
    },
    payment() {
      track('Order Payment Processed');
    },
    update() {
      track('Order Updated');
    },
    create() {
      track('Order Created');
    },
    cancel() {
      track('Order Canceled');
    },
  },
  export: {
    generate(info: { name: string; start: string; end: string }) {
      track('Report Generated', info);
    },
  },
};



// WEBPACK FOOTER //
// ./src/common/utils/Analytics.ts